/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class BusinessNotifyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 检查是否存在自定义指定业务相同通知类型的通知配置
     * @param businessKey businessKey
     * @param notifyType notifyType
     * @return OK
     */
    checkIsExistsCustomBusinessNotify(businessKey: string, notifyType: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/business-notify/checkIsExistsCustomBusinessNotify?";
        if (businessKey === undefined || businessKey === null)
            throw new Error("The parameter 'businessKey' must be defined and cannot be null.");
        else
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (notifyType === undefined || notifyType === null)
            throw new Error("The parameter 'notifyType' must be defined and cannot be null.");
        else
            url_ += "notifyType=" + encodeURIComponent("" + notifyType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckIsExistsCustomBusinessNotify(_response);
        });
    }

    protected processCheckIsExistsCustomBusinessNotify(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页
     * @param businessKey (optional) 业务key
     * @param notifyId (optional) 通知配置
     * @param notifyTemplateId (optional) 通知模板
     * @param notifyType (optional) 通知类型
     * @param pageNo pageNo
     * @param pageSize pageSize
     * @return OK
     */
    list(businessKey: string | null | undefined, notifyId: string | null | undefined, notifyTemplateId: string | null | undefined, notifyType: string | null | undefined, pageNo: number, pageSize: number): Promise<IPageOfBusinessNotifyDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/business-notify/list?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (notifyId !== undefined)
            url_ += "notifyId=" + encodeURIComponent("" + notifyId) + "&"; 
        if (notifyTemplateId !== undefined)
            url_ += "notifyTemplateId=" + encodeURIComponent("" + notifyTemplateId) + "&"; 
        if (notifyType !== undefined)
            url_ += "notifyType=" + encodeURIComponent("" + notifyType) + "&"; 
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IPageOfBusinessNotifyDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfBusinessNotifyDTO.fromJS(resultData200) : new IPageOfBusinessNotifyDTO();
            return result200;
        }
        return Promise.resolve<IPageOfBusinessNotifyDTO>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    remove(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/business-notify/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增或修改
     * @param businessNotify businessNotify
     * @return OK
     */
    submit(businessNotify: BusinessNotifyDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/business-notify/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessNotify);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class MessageNotificationRulesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除消息通知规则
     * @param idList (optional) 通知规则业务Id集合
     * @return OK
     */
    deleteMessageNotificationRules(idList: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/message-notification-rules/delete?";
        if (idList !== undefined)
            idList && idList.forEach(item => { url_ += "idList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMessageNotificationRules(_response);
        });
    }

    protected processDeleteMessageNotificationRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获得消息通知规则
     * @param id id
     * @param type (optional) 1-全局字典，2-业务字典
     * @return OK
     */
    getMessageNotificationRules(id: string, type: number | null | undefined): Promise<MessageNotificationRulesDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/message-notification-rules/get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMessageNotificationRules(_response);
        });
    }

    protected processGetMessageNotificationRules(response: AxiosResponse): Promise<MessageNotificationRulesDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MessageNotificationRulesDTO.fromJS(resultData200) : new MessageNotificationRulesDTO();
            return result200;
        }
        return Promise.resolve<MessageNotificationRulesDTO>(<any>null);
    }

    /**
     * 查询消息通知规则
     * @param current (optional) 当前页
     * @param ruleId (optional) 通知规则业务Id
     * @param size (optional) 每页的数量
     * @param type (optional) 1-全局字典，2-业务字典
     * @return OK
     */
    queryMessageNotificationRules(current: number | null | undefined, ruleId: string | null | undefined, size: number | null | undefined, type: number | null | undefined): Promise<IPageOfMessageNotificationRulesDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/message-notification-rules/page?";
        if (ruleId !== undefined)
            url_ += "ruleId=" + encodeURIComponent("" + ruleId) + "&"; 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMessageNotificationRules(_response);
        });
    }

    protected processQueryMessageNotificationRules(response: AxiosResponse): Promise<IPageOfMessageNotificationRulesDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMessageNotificationRulesDTO.fromJS(resultData200) : new IPageOfMessageNotificationRulesDTO();
            return result200;
        }
        return Promise.resolve<IPageOfMessageNotificationRulesDTO>(<any>null);
    }

    /**
     * 新建或更新消息通知规则
     * @param messageNotificationRulesDTO messageNotificationRulesDTO
     * @return OK
     */
    submit(messageNotificationRulesDTO: MessageNotificationRulesDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/message-notification-rules/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageNotificationRulesDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class NotificationRuleBusinessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除通知规则业务
     * @param id id
     * @return OK
     */
    deleteNotificationRuleBusiness(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notification-rule-business/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteNotificationRuleBusiness(_response);
        });
    }

    protected processDeleteNotificationRuleBusiness(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取通知规则业务
     * @param id id
     * @return OK
     */
    getNotificationRuleBusiness(id: string): Promise<NotificationRuleBusinessDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notification-rule-business/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNotificationRuleBusiness(_response);
        });
    }

    protected processGetNotificationRuleBusiness(response: AxiosResponse): Promise<NotificationRuleBusinessDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NotificationRuleBusinessDTO.fromJS(resultData200) : new NotificationRuleBusinessDTO();
            return result200;
        }
        return Promise.resolve<NotificationRuleBusinessDTO>(<any>null);
    }

    /**
     * 查询通知规则业务
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    queryNotificationRuleBusiness(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfNotificationRuleBusinessDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notification-rule-business/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryNotificationRuleBusiness(_response);
        });
    }

    protected processQueryNotificationRuleBusiness(response: AxiosResponse): Promise<IPageOfNotificationRuleBusinessDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotificationRuleBusinessDTO.fromJS(resultData200) : new IPageOfNotificationRuleBusinessDTO();
            return result200;
        }
        return Promise.resolve<IPageOfNotificationRuleBusinessDTO>(<any>null);
    }

    /**
     * 新建或更新通知规则业务
     * @param notificationRuleBusinessDTO notificationRuleBusinessDTO
     * @return OK
     */
    submit(notificationRuleBusinessDTO: NotificationRuleBusinessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notification-rule-business/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationRuleBusinessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class NotificationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询通知记录
     * @param businessKey (optional) 
     * @param businessName (optional) 
     * @param current (optional) 当前页
     * @param id (optional) 
     * @param message (optional) 
     * @param notifyTime (optional) 
     * @param size (optional) 每页的数量
     * @param subscribeId (optional) 
     * @param subscriber (optional) 
     * @return OK
     */
    queryMyNotifications(businessKey: string | null | undefined, businessName: string | null | undefined, current: number | null | undefined, id: string | null | undefined, message: string | null | undefined, notifyTime: string | null | undefined, size: number | null | undefined, subscribeId: string | null | undefined, subscriber: string | null | undefined): Promise<IPageOfNotification> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/query?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (businessName !== undefined)
            url_ += "businessName=" + encodeURIComponent("" + businessName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (notifyTime !== undefined)
            url_ += "notifyTime=" + encodeURIComponent("" + notifyTime) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (subscribeId !== undefined)
            url_ += "subscribeId=" + encodeURIComponent("" + subscribeId) + "&"; 
        if (subscriber !== undefined)
            url_ += "subscriber=" + encodeURIComponent("" + subscriber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryMyNotifications(_response);
        });
    }

    protected processQueryMyNotifications(response: AxiosResponse): Promise<IPageOfNotification> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotification.fromJS(resultData200) : new IPageOfNotification();
            return result200;
        }
        return Promise.resolve<IPageOfNotification>(<any>null);
    }

    /**
     * 订阅通知
     * @param subscribe subscribe
     * @return OK
     */
    doSubscribe(subscribe: NotifySubscriberDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscribe);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDoSubscribe(_response);
        });
    }

    protected processDoSubscribe(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除订阅
     * @param id id
     * @return OK
     */
    deleteSubscription(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/subscription/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteSubscription(_response);
        });
    }

    protected processDeleteSubscription(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改通知订阅状态
     * @param id id
     * @param state state
     * @return OK
     */
    changeSubscribeState(id: string, state: number): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/subscription/{id}/{state}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeSubscribeState(_response);
        });
    }

    protected processChangeSubscribeState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询当前用户订阅信息
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    querySubscription(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfNotifySubscriberDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/subscriptions/query?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQuerySubscription(_response);
        });
    }

    protected processQuerySubscription(response: AxiosResponse): Promise<IPageOfNotifySubscriberDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotifySubscriberDTO.fromJS(resultData200) : new IPageOfNotifySubscriberDTO();
            return result200;
        }
        return Promise.resolve<IPageOfNotifySubscriberDTO>(<any>null);
    }

    /**
     * 获取通知记录
     * @param id id
     * @return OK
     */
    readNotification(id: string): Promise<Notification> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/{id}/read";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReadNotification(_response);
        });
    }

    protected processReadNotification(response: AxiosResponse): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Notification.fromJS(resultData200) : new Notification();
            return result200;
        }
        return Promise.resolve<Notification>(<any>null);
    }

    /**
     * 修改通知状态
     * @param idList idList
     * @param state state
     * @return OK
     */
    changeNotificationState(idList: string[], state: number): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifications/{state}";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeNotificationState(_response);
        });
    }

    protected processChangeNotificationState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class NotifierConfigServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或修改
     * @param notifyConfigDTO notifyConfigDTO
     * @return OK
     */
    submit(notifyConfigDTO: NotifyConfigDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notifyConfigDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 业务通知可选的通知配置
     * @param notifyType notifyType
     * @return OK
     */
    getAvailableNotifyConfig(notifyType: string): Promise<NotifyConfigDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/available?";
        if (notifyType === undefined || notifyType === null)
            throw new Error("The parameter 'notifyType' must be defined and cannot be null.");
        else
            url_ += "notifyType=" + encodeURIComponent("" + notifyType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableNotifyConfig(_response);
        });
    }

    protected processGetAvailableNotifyConfig(response: AxiosResponse): Promise<NotifyConfigDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotifyConfigDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<NotifyConfigDTO[]>(<any>null);
    }

    /**
     * 详情
     * @param configId configId
     * @return OK
     */
    detail(configId: string): Promise<NotifyConfigDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/detail/{configId}";
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined.");
        url_ = url_.replace("{configId}", encodeURIComponent("" + configId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<NotifyConfigDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NotifyConfigDTO.fromJS(resultData200) : new NotifyConfigDTO();
            return result200;
        }
        return Promise.resolve<NotifyConfigDTO>(<any>null);
    }

    /**
     * 通知列表
     * @param current (optional) 当前页
     * @param name (optional) 配置名称
     * @param provider (optional) 服务提供商
     * @param size (optional) 每页的数量
     * @param type (optional) 通知类型
     * @return OK
     */
    configPageList(current: number | null | undefined, name: string | null | undefined, provider: string | null | undefined, size: number | null | undefined, type: string | null | undefined): Promise<IPageOfNotifyConfigDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfigPageList(_response);
        });
    }

    protected processConfigPageList(response: AxiosResponse): Promise<IPageOfNotifyConfigDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotifyConfigDTO.fromJS(resultData200) : new IPageOfNotifyConfigDTO();
            return result200;
        }
        return Promise.resolve<IPageOfNotifyConfigDTO>(<any>null);
    }

    /**
     * 获取支持的服务商
     * @param type 通知类型ID类型标识
     * @return OK
     */
    getTypeProviders(type: string): Promise<ProviderInfo[]> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/type/{type}/providers";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTypeProviders(_response);
        });
    }

    protected processGetTypeProviders(response: AxiosResponse): Promise<ProviderInfo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderInfo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProviderInfo[]>(<any>null);
    }

    /**
     * 获取平台支持的通知类型
     * @return OK
     */
    getAllNotifyTypes(): Promise<NotifyTypeInfo[]> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllNotifyTypes(_response);
        });
    }

    protected processGetAllNotifyTypes(response: AxiosResponse): Promise<NotifyTypeInfo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotifyTypeInfo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<NotifyTypeInfo[]>(<any>null);
    }

    /**
     * 删除
     * @param id 主键
     * @return OK
     */
    remove(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取指定类型和服务商所需配置定义
     * @param provider 服务商ID
     * @param type 通知类型ID
     * @return OK
     */
    getAllTypes(provider: string, type: string): Promise<ConfigMetadata> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/config/{type}/{provider}/metadata";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider)); 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllTypes(_response);
        });
    }

    protected processGetAllTypes(response: AxiosResponse): Promise<ConfigMetadata> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ConfigMetadata.fromJS(resultData200) : new ConfigMetadata();
            return result200;
        }
        return Promise.resolve<ConfigMetadata>(<any>null);
    }
}

export class NotifierTemplateServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或修改
     * @param notifyTemplateDTO notifyTemplateDTO
     * @return OK
     */
    submit(notifyTemplateDTO: NotifyTemplateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notifyTemplateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 详情
     * @param templateId templateId
     * @return OK
     */
    detail(templateId: string): Promise<NotifyTemplateDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template/detail/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<NotifyTemplateDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? NotifyTemplateDTO.fromJS(resultData200) : new NotifyTemplateDTO();
            return result200;
        }
        return Promise.resolve<NotifyTemplateDTO>(<any>null);
    }

    /**
     * 通知模板列表
     * @param businessKey (optional) 关联业务
     * @param current (optional) 当前页
     * @param name (optional) 模版名称
     * @param provider (optional) 通知服务商ID
     * @param size (optional) 每页的数量
     * @param type (optional) 通知类型
     * @return OK
     */
    configPageList(businessKey: string | null | undefined, current: number | null | undefined, name: string | null | undefined, provider: string | null | undefined, size: number | null | undefined, type: string | null | undefined): Promise<IPageOfNotifyTemplateDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template/list?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfigPageList(_response);
        });
    }

    protected processConfigPageList(response: AxiosResponse): Promise<IPageOfNotifyTemplateDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotifyTemplateDTO.fromJS(resultData200) : new IPageOfNotifyTemplateDTO();
            return result200;
        }
        return Promise.resolve<IPageOfNotifyTemplateDTO>(<any>null);
    }

    /**
     * 业务通知可用的通知模板
     * @param businessKey businessKey
     * @param notifyId notifyId
     * @return OK
     */
    getCanUseNotifyConfig(businessKey: string, notifyId: string): Promise<NameValueOfstring[]> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template/select?";
        if (businessKey === undefined || businessKey === null)
            throw new Error("The parameter 'businessKey' must be defined and cannot be null.");
        else
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (notifyId === undefined || notifyId === null)
            throw new Error("The parameter 'notifyId' must be defined and cannot be null.");
        else
            url_ += "notifyId=" + encodeURIComponent("" + notifyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCanUseNotifyConfig(_response);
        });
    }

    protected processGetCanUseNotifyConfig(response: AxiosResponse): Promise<NameValueOfstring[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfstring.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<NameValueOfstring[]>(<any>null);
    }

    /**
     * 删除
     * @param id 主键
     * @return OK
     */
    remove(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取指定类型和服务商所需模版配置定义
     * @param provider provider
     * @param type type
     * @return OK
     */
    getAllTypes(provider: string, type: string): Promise<ConfigMetadata> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/template/{type}/{provider}/config/metadata";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider)); 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllTypes(_response);
        });
    }

    protected processGetAllTypes(response: AxiosResponse): Promise<ConfigMetadata> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ConfigMetadata.fromJS(resultData200) : new ConfigMetadata();
            return result200;
        }
        return Promise.resolve<ConfigMetadata>(<any>null);
    }
}

export class NotifierServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 发送消息通知
     * @param mono mono
     * @param notifierId 通知配置ID
     * @return OK
     */
    sendNotify(mono: SendNotifyRequest, notifierId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notifier/{notifierId}/send";
        if (notifierId === undefined || notifierId === null)
            throw new Error("The parameter 'notifierId' must be defined.");
        url_ = url_.replace("{notifierId}", encodeURIComponent("" + notifierId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mono);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendNotify(_response);
        });
    }

    protected processSendNotify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class NotifierHistoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 消息通知记录列表
     * @param current (optional) 当前页
     * @param notifyType (optional) 通知类型
     * @param provider (optional) 服务商
     * @param size (optional) 每页的数量
     * @param state (optional) 通知状态
     * @return OK
     */
    configPageList(current: number | null | undefined, notifyType: string | null | undefined, provider: string | null | undefined, size: number | null | undefined, state: State | null | undefined): Promise<IPageOfNotifyHistoryDTO> {
        let url_ = this.baseUrl + this.covertUrl('www-alpha.masterlink.cloud/masterlink-notify')+ "/notify/history/list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (notifyType !== undefined)
            url_ += "notifyType=" + encodeURIComponent("" + notifyType) + "&"; 
        if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfigPageList(_response);
        });
    }

    protected processConfigPageList(response: AxiosResponse): Promise<IPageOfNotifyHistoryDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfNotifyHistoryDTO.fromJS(resultData200) : new IPageOfNotifyHistoryDTO();
            return result200;
        }
        return Promise.resolve<IPageOfNotifyHistoryDTO>(<any>null);
    }
}

export class BusinessNotifyDTO implements IBusinessNotifyDTO {
    /** 业务key */
    businessKey!: string | undefined;
    /** 业务名称 */
    businessName!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否系统配置: 1:是 0:否 */
    isDefault!: number | undefined;
    /** 通知配置 */
    notifyId!: string | undefined;
    /** 通知配置名称 */
    notifyName!: string | undefined;
    /** 通知模板 */
    notifyTemplateId!: string | undefined;
    /** 通知模板名称 */
    notifyTemplateName!: string | undefined;
    /** 通知类型 */
    notifyType!: string | undefined;
    /** 租户Id */
    tenantId!: string | undefined;

    constructor(data?: IBusinessNotifyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessKey = data["businessKey"];
            this.businessName = data["businessName"];
            this.id = data["id"];
            this.isDefault = data["isDefault"];
            this.notifyId = data["notifyId"];
            this.notifyName = data["notifyName"];
            this.notifyTemplateId = data["notifyTemplateId"];
            this.notifyTemplateName = data["notifyTemplateName"];
            this.notifyType = data["notifyType"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BusinessNotifyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessNotifyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessKey"] = this.businessKey;
        data["businessName"] = this.businessName;
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["notifyId"] = this.notifyId;
        data["notifyName"] = this.notifyName;
        data["notifyTemplateId"] = this.notifyTemplateId;
        data["notifyTemplateName"] = this.notifyTemplateName;
        data["notifyType"] = this.notifyType;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBusinessNotifyDTO {
    /** 业务key */
    businessKey: string | undefined;
    /** 业务名称 */
    businessName: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否系统配置: 1:是 0:否 */
    isDefault: number | undefined;
    /** 通知配置 */
    notifyId: string | undefined;
    /** 通知配置名称 */
    notifyName: string | undefined;
    /** 通知模板 */
    notifyTemplateId: string | undefined;
    /** 通知模板名称 */
    notifyTemplateName: string | undefined;
    /** 通知类型 */
    notifyType: string | undefined;
    /** 租户Id */
    tenantId: string | undefined;
}

export class ConfigMetadata implements IConfigMetadata {
    description!: string | undefined;
    name!: string | undefined;
    properties!: ConfigPropertyMetadata[] | undefined;

    constructor(data?: IConfigMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            if (data["properties"] && data["properties"].constructor === Array) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(ConfigPropertyMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        if (this.properties && this.properties.constructor === Array) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IConfigMetadata {
    description: string | undefined;
    name: string | undefined;
    properties: ConfigPropertyMetadata[] | undefined;
}

export class ConfigPropertyMetadata implements IConfigPropertyMetadata {
    description!: string | undefined;
    name!: string | undefined;
    property!: string | undefined;
    type!: DataType | undefined;

    constructor(data?: IConfigPropertyMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            this.property = data["property"];
            this.type = data["type"] ? DataType.fromJS(data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfigPropertyMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigPropertyMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["property"] = this.property;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IConfigPropertyMetadata {
    description: string | undefined;
    name: string | undefined;
    property: string | undefined;
    type: DataType | undefined;
}

export class DataType implements IDataType {
    description!: string | undefined;
    expands!: any | undefined;
    id!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;

    constructor(data?: IDataType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.expands = data["expands"];
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): DataType {
        data = typeof data === 'object' ? data : {};
        let result = new DataType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["expands"] = this.expands;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IDataType {
    description: string | undefined;
    expands: any | undefined;
    id: string | undefined;
    name: string | undefined;
    type: string | undefined;
}

export class IPageOfBusinessNotifyDTO implements IIPageOfBusinessNotifyDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: BusinessNotifyDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfBusinessNotifyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(BusinessNotifyDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfBusinessNotifyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfBusinessNotifyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfBusinessNotifyDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: BusinessNotifyDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMessageNotificationRulesDTO implements IIPageOfMessageNotificationRulesDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MessageNotificationRulesDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMessageNotificationRulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MessageNotificationRulesDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMessageNotificationRulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMessageNotificationRulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMessageNotificationRulesDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MessageNotificationRulesDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotification implements IIPageOfNotification {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: Notification[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(Notification.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotification {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotification {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: Notification[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotificationRuleBusinessDTO implements IIPageOfNotificationRuleBusinessDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: NotificationRuleBusinessDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotificationRuleBusinessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(NotificationRuleBusinessDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotificationRuleBusinessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotificationRuleBusinessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotificationRuleBusinessDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: NotificationRuleBusinessDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotifyConfigDTO implements IIPageOfNotifyConfigDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: NotifyConfigDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotifyConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(NotifyConfigDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotifyConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotifyConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotifyConfigDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: NotifyConfigDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotifyHistoryDTO implements IIPageOfNotifyHistoryDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: NotifyHistoryDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotifyHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(NotifyHistoryDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotifyHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotifyHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotifyHistoryDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: NotifyHistoryDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotifySubscriberDTO implements IIPageOfNotifySubscriberDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: NotifySubscriberDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotifySubscriberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(NotifySubscriberDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotifySubscriberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotifySubscriberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotifySubscriberDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: NotifySubscriberDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfNotifyTemplateDTO implements IIPageOfNotifyTemplateDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: NotifyTemplateDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfNotifyTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(NotifyTemplateDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfNotifyTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfNotifyTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfNotifyTemplateDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: NotifyTemplateDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class MessageNotificationRulesDTO implements IMessageNotificationRulesDTO {
    /** 规则key */
    dictKey!: string | undefined;
    /** 结束时间(时分秒) */
    endTime!: string | undefined;
    /** 首次触发条件(单位分钟) */
    firstTriggerCondition!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    incrementCondition!: number | undefined;
    /** 是否启用（0:未启用；1：启用） */
    isEnable!: number | undefined;
    /** 是否启用描述（0:未启用；1：启用） */
    isEnableDesc!: string | undefined;
    /** 通知名称 */
    notificationName!: number | undefined;
    /** 通知名称描述 */
    notificationNameDesc!: string | undefined;
    /** 通知时间范围(1:按照工厂日历；2：自定义时间) */
    notificationTimeRange!: number | undefined;
    /** 通知时间范围描述(1:按照工厂日历；2：自定义时间) */
    notificationTimeRangeDesc!: string | undefined;
    /** 通知人员编码 */
    notificationUserCode!: string | undefined;
    /** 通知人员Id */
    notificationUserId!: string | undefined;
    /** 通知人员名称 */
    notificationUserName!: string | undefined;
    /** 通知规则业务Id */
    ruleId!: string | undefined;
    /** 发送次数上限 */
    sendNumberLimit!: number | undefined;
    /** 排序 */
    sort!: number | undefined;
    /** 开始时间(时分秒) */
    startTime!: string | undefined;

    constructor(data?: IMessageNotificationRulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dictKey = data["dictKey"];
            this.endTime = data["endTime"];
            this.firstTriggerCondition = data["firstTriggerCondition"];
            this.id = data["id"];
            this.incrementCondition = data["incrementCondition"];
            this.isEnable = data["isEnable"];
            this.isEnableDesc = data["isEnableDesc"];
            this.notificationName = data["notificationName"];
            this.notificationNameDesc = data["notificationNameDesc"];
            this.notificationTimeRange = data["notificationTimeRange"];
            this.notificationTimeRangeDesc = data["notificationTimeRangeDesc"];
            this.notificationUserCode = data["notificationUserCode"];
            this.notificationUserId = data["notificationUserId"];
            this.notificationUserName = data["notificationUserName"];
            this.ruleId = data["ruleId"];
            this.sendNumberLimit = data["sendNumberLimit"];
            this.sort = data["sort"];
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): MessageNotificationRulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageNotificationRulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dictKey"] = this.dictKey;
        data["endTime"] = this.endTime;
        data["firstTriggerCondition"] = this.firstTriggerCondition;
        data["id"] = this.id;
        data["incrementCondition"] = this.incrementCondition;
        data["isEnable"] = this.isEnable;
        data["isEnableDesc"] = this.isEnableDesc;
        data["notificationName"] = this.notificationName;
        data["notificationNameDesc"] = this.notificationNameDesc;
        data["notificationTimeRange"] = this.notificationTimeRange;
        data["notificationTimeRangeDesc"] = this.notificationTimeRangeDesc;
        data["notificationUserCode"] = this.notificationUserCode;
        data["notificationUserId"] = this.notificationUserId;
        data["notificationUserName"] = this.notificationUserName;
        data["ruleId"] = this.ruleId;
        data["sendNumberLimit"] = this.sendNumberLimit;
        data["sort"] = this.sort;
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface IMessageNotificationRulesDTO {
    /** 规则key */
    dictKey: string | undefined;
    /** 结束时间(时分秒) */
    endTime: string | undefined;
    /** 首次触发条件(单位分钟) */
    firstTriggerCondition: number | undefined;
    /** 主键 */
    id: string | undefined;
    incrementCondition: number | undefined;
    /** 是否启用（0:未启用；1：启用） */
    isEnable: number | undefined;
    /** 是否启用描述（0:未启用；1：启用） */
    isEnableDesc: string | undefined;
    /** 通知名称 */
    notificationName: number | undefined;
    /** 通知名称描述 */
    notificationNameDesc: string | undefined;
    /** 通知时间范围(1:按照工厂日历；2：自定义时间) */
    notificationTimeRange: number | undefined;
    /** 通知时间范围描述(1:按照工厂日历；2：自定义时间) */
    notificationTimeRangeDesc: string | undefined;
    /** 通知人员编码 */
    notificationUserCode: string | undefined;
    /** 通知人员Id */
    notificationUserId: string | undefined;
    /** 通知人员名称 */
    notificationUserName: string | undefined;
    /** 通知规则业务Id */
    ruleId: string | undefined;
    /** 发送次数上限 */
    sendNumberLimit: number | undefined;
    /** 排序 */
    sort: number | undefined;
    /** 开始时间(时分秒) */
    startTime: string | undefined;
}

export class NameValueOfstring implements INameValueOfstring {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfstring {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfstring {
    name: string | undefined;
    value: string | undefined;
}

export class Notification implements INotification {
    businessKey!: string | undefined;
    businessName!: string | undefined;
    id!: string | undefined;
    message!: string | undefined;
    notifyTime!: string | undefined;
    subscribeId!: string | undefined;
    subscriber!: string | undefined;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessKey = data["businessKey"];
            this.businessName = data["businessName"];
            this.id = data["id"];
            this.message = data["message"];
            this.notifyTime = data["notifyTime"];
            this.subscribeId = data["subscribeId"];
            this.subscriber = data["subscriber"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessKey"] = this.businessKey;
        data["businessName"] = this.businessName;
        data["id"] = this.id;
        data["message"] = this.message;
        data["notifyTime"] = this.notifyTime;
        data["subscribeId"] = this.subscribeId;
        data["subscriber"] = this.subscriber;
        return data; 
    }
}

export interface INotification {
    businessKey: string | undefined;
    businessName: string | undefined;
    id: string | undefined;
    message: string | undefined;
    notifyTime: string | undefined;
    subscribeId: string | undefined;
    subscriber: string | undefined;
}

export class NotificationRuleBusinessDTO implements INotificationRuleBusinessDTO {
    /** 业务key */
    dictKey!: string | undefined;
    /** 业务名称 */
    dictName!: string | undefined;
    /** 工位组ID */
    groupId!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 规则 */
    ruleList!: MessageNotificationRulesDTO[] | undefined;
    /** 规则名称 */
    ruleName!: string | undefined;
    /** 工位ID */
    workstationId!: string | undefined;

    constructor(data?: INotificationRuleBusinessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dictKey = data["dictKey"];
            this.dictName = data["dictName"];
            this.groupId = data["groupId"];
            this.id = data["id"];
            if (data["ruleList"] && data["ruleList"].constructor === Array) {
                this.ruleList = [] as any;
                for (let item of data["ruleList"])
                    this.ruleList!.push(MessageNotificationRulesDTO.fromJS(item));
            }
            this.ruleName = data["ruleName"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): NotificationRuleBusinessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRuleBusinessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dictKey"] = this.dictKey;
        data["dictName"] = this.dictName;
        data["groupId"] = this.groupId;
        data["id"] = this.id;
        if (this.ruleList && this.ruleList.constructor === Array) {
            data["ruleList"] = [];
            for (let item of this.ruleList)
                data["ruleList"].push(item.toJSON());
        }
        data["ruleName"] = this.ruleName;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface INotificationRuleBusinessDTO {
    /** 业务key */
    dictKey: string | undefined;
    /** 业务名称 */
    dictName: string | undefined;
    /** 工位组ID */
    groupId: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 规则 */
    ruleList: MessageNotificationRulesDTO[] | undefined;
    /** 规则名称 */
    ruleName: string | undefined;
    /** 工位ID */
    workstationId: string | undefined;
}

export class NotifyConfigDTO implements INotifyConfigDTO {
    /** 配置信息 */
    configuration!: any | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 配置名称 */
    name!: string | undefined;
    /** 服务提供商 */
    provider!: string | undefined;
    /** 通知类型 */
    type!: string | undefined;

    constructor(data?: INotifyConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.configuration = data["configuration"];
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.provider = data["provider"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): NotifyConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["provider"] = this.provider;
        data["type"] = this.type;
        return data; 
    }
}

export interface INotifyConfigDTO {
    /** 配置信息 */
    configuration: any | undefined;
    /** 描述 */
    description: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 配置名称 */
    name: string | undefined;
    /** 服务提供商 */
    provider: string | undefined;
    /** 通知类型 */
    type: string | undefined;
}

export class NotifyHistoryDTO implements INotifyHistoryDTO {
    /** 上下文 */
    context!: any | undefined;
    /** 异常栈 */
    errorStack!: string | undefined;
    /** 错误类型 */
    errorType!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 通知ID */
    notifierId!: string | undefined;
    /** 通知时间 */
    notifyTime!: Date | undefined;
    /** 通知类型 */
    notifyType!: string | undefined;
    /** 服务商 */
    provider!: string | undefined;
    /** 重试次数 */
    retryTimes!: number | undefined;
    /** 通知状态 */
    state!: NotifyHistoryDTOState | undefined;
    /** 模版内容 */
    template!: string | undefined;
    /** 模版ID */
    templateId!: string | undefined;
    /** 追溯ID */
    tranceId!: string | undefined;

    constructor(data?: INotifyHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.context = data["context"];
            this.errorStack = data["errorStack"];
            this.errorType = data["errorType"];
            this.id = data["id"];
            this.notifierId = data["notifierId"];
            this.notifyTime = data["notifyTime"] ? new Date(data["notifyTime"].toString()) : <any>undefined;
            this.notifyType = data["notifyType"];
            this.provider = data["provider"];
            this.retryTimes = data["retryTimes"];
            this.state = data["state"];
            this.template = data["template"];
            this.templateId = data["templateId"];
            this.tranceId = data["tranceId"];
        }
    }

    static fromJS(data: any): NotifyHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context;
        data["errorStack"] = this.errorStack;
        data["errorType"] = this.errorType;
        data["id"] = this.id;
        data["notifierId"] = this.notifierId;
        data["notifyTime"] = this.notifyTime ? this.notifyTime.toISOString() : <any>undefined;
        data["notifyType"] = this.notifyType;
        data["provider"] = this.provider;
        data["retryTimes"] = this.retryTimes;
        data["state"] = this.state;
        data["template"] = this.template;
        data["templateId"] = this.templateId;
        data["tranceId"] = this.tranceId;
        return data; 
    }
}

export interface INotifyHistoryDTO {
    /** 上下文 */
    context: any | undefined;
    /** 异常栈 */
    errorStack: string | undefined;
    /** 错误类型 */
    errorType: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 通知ID */
    notifierId: string | undefined;
    /** 通知时间 */
    notifyTime: Date | undefined;
    /** 通知类型 */
    notifyType: string | undefined;
    /** 服务商 */
    provider: string | undefined;
    /** 重试次数 */
    retryTimes: number | undefined;
    /** 通知状态 */
    state: NotifyHistoryDTOState | undefined;
    /** 模版内容 */
    template: string | undefined;
    /** 模版ID */
    templateId: string | undefined;
    /** 追溯ID */
    tranceId: string | undefined;
}

export class NotifySubscriberDTO implements INotifySubscriberDTO {
    /** 主题提供商标识,如:device_alarm */
    businessKey!: string | undefined;
    /** 订阅名称 */
    businessName!: string | undefined;
    /** 描述说明 */
    description!: string | undefined;
    id!: string | undefined;
    /** 通知主题订阅,status: 1.订阅中,2.停止 */
    status!: number | undefined;
    /** 订阅者ID */
    subscriber!: string | undefined;
    /** 订阅配置,根据主题标识不同而不同. */
    topicConfig!: any | undefined;

    constructor(data?: INotifySubscriberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessKey = data["businessKey"];
            this.businessName = data["businessName"];
            this.description = data["description"];
            this.id = data["id"];
            this.status = data["status"];
            this.subscriber = data["subscriber"];
            this.topicConfig = data["topicConfig"];
        }
    }

    static fromJS(data: any): NotifySubscriberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifySubscriberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessKey"] = this.businessKey;
        data["businessName"] = this.businessName;
        data["description"] = this.description;
        data["id"] = this.id;
        data["status"] = this.status;
        data["subscriber"] = this.subscriber;
        data["topicConfig"] = this.topicConfig;
        return data; 
    }
}

export interface INotifySubscriberDTO {
    /** 主题提供商标识,如:device_alarm */
    businessKey: string | undefined;
    /** 订阅名称 */
    businessName: string | undefined;
    /** 描述说明 */
    description: string | undefined;
    id: string | undefined;
    /** 通知主题订阅,status: 1.订阅中,2.停止 */
    status: number | undefined;
    /** 订阅者ID */
    subscriber: string | undefined;
    /** 订阅配置,根据主题标识不同而不同. */
    topicConfig: any | undefined;
}

export class NotifyTemplateDTO implements INotifyTemplateDTO {
    /** 关联业务 */
    business!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 模版名称 */
    name!: string | undefined;
    /** 通知服务商ID */
    provider!: string | undefined;
    /** 模版内容(根据服务商不同而不同) */
    template!: string | undefined;
    /** 通知类型 */
    type!: string | undefined;

    constructor(data?: INotifyTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.business = data["business"];
            this.id = data["id"];
            this.name = data["name"];
            this.provider = data["provider"];
            this.template = data["template"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): NotifyTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business;
        data["id"] = this.id;
        data["name"] = this.name;
        data["provider"] = this.provider;
        data["template"] = this.template;
        data["type"] = this.type;
        return data; 
    }
}

export interface INotifyTemplateDTO {
    /** 关联业务 */
    business: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 模版名称 */
    name: string | undefined;
    /** 通知服务商ID */
    provider: string | undefined;
    /** 模版内容(根据服务商不同而不同) */
    template: string | undefined;
    /** 通知类型 */
    type: string | undefined;
}

export class NotifyTypeInfo implements INotifyTypeInfo {
    /** 通知类型ID */
    id!: string | undefined;
    /** 通知类型名称 */
    name!: string | undefined;
    /** 服务商信息 */
    providerInfos!: ProviderInfo[] | undefined;

    constructor(data?: INotifyTypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (data["providerInfos"] && data["providerInfos"].constructor === Array) {
                this.providerInfos = [] as any;
                for (let item of data["providerInfos"])
                    this.providerInfos!.push(ProviderInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotifyTypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyTypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.providerInfos && this.providerInfos.constructor === Array) {
            data["providerInfos"] = [];
            for (let item of this.providerInfos)
                data["providerInfos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INotifyTypeInfo {
    /** 通知类型ID */
    id: string | undefined;
    /** 通知类型名称 */
    name: string | undefined;
    /** 服务商信息 */
    providerInfos: ProviderInfo[] | undefined;
}

export class ProviderInfo implements IProviderInfo {
    /** 服务商ID */
    id!: string | undefined;
    /** 服务商名称 */
    name!: string | undefined;
    /** 通知类型 */
    type!: string | undefined;

    constructor(data?: IProviderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ProviderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface IProviderInfo {
    /** 服务商ID */
    id: string | undefined;
    /** 服务商名称 */
    name: string | undefined;
    /** 通知类型 */
    type: string | undefined;
}

export class SendNotifyRequest implements ISendNotifyRequest {
    /** 上下文数据 */
    context!: any | undefined;
    /** 被通知者 */
    notifiedParty!: string[] | undefined;
    /** 通知模版 */
    template!: 通知模板 | undefined;

    constructor(data?: ISendNotifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.context = data["context"];
            if (data["notifiedParty"] && data["notifiedParty"].constructor === Array) {
                this.notifiedParty = [] as any;
                for (let item of data["notifiedParty"])
                    this.notifiedParty!.push(item);
            }
            this.template = data["template"] ? 通知模板.fromJS(data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendNotifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context;
        if (this.notifiedParty && this.notifiedParty.constructor === Array) {
            data["notifiedParty"] = [];
            for (let item of this.notifiedParty)
                data["notifiedParty"].push(item);
        }
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISendNotifyRequest {
    /** 上下文数据 */
    context: any | undefined;
    /** 被通知者 */
    notifiedParty: string[] | undefined;
    /** 通知模版 */
    template: 通知模板 | undefined;
}

/** 通知模板 */
export class 通知模板 implements I通知模板 {
    /** 关联业务 */
    business!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 模版名称 */
    name!: string | undefined;
    /** 通知服务商ID */
    provider!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 模版内容(根据服务商不同而不同) */
    template!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 通知类型 */
    type!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: I通知模板) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.business = data["business"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.provider = data["provider"];
            this.status = data["status"];
            this.template = data["template"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): 通知模板 {
        data = typeof data === 'object' ? data : {};
        let result = new 通知模板();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["provider"] = this.provider;
        data["status"] = this.status;
        data["template"] = this.template;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 通知模板 */
export interface I通知模板 {
    /** 关联业务 */
    business: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 模版名称 */
    name: string | undefined;
    /** 通知服务商ID */
    provider: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 模版内容(根据服务商不同而不同) */
    template: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 通知类型 */
    type: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 通知状态 */
export enum State {
    Success = "success", 
    Error = "error", 
}

export enum NotifyHistoryDTOState {
    Success = "success", 
    Error = "error", 
}